import { reduxPhaseTypes } from 'src/types';
import { PHASE_SET, PHASE_ADDED, PHASE_EDITED, PHASE_DELETED } from '../redux-types';

export const phaseDefaultState: reduxPhaseTypes.StateType = {
  phaseList: [],
};

export const phaseReducer = (
  state = phaseDefaultState,
  action: reduxPhaseTypes.ActionType,
): reduxPhaseTypes.StateType => {
  switch (action.type) {
    case PHASE_SET:
      return {
        ...state,
        phaseList: action.payload,
      };
    case PHASE_ADDED:
      const exists = state.phaseList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        phaseList: [action.payload, ...state.phaseList],
      };
    case PHASE_EDITED:
      const updateIndex = state.phaseList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        phaseList: [
          ...state.phaseList.slice(0, updateIndex),
          action.payload,
          ...state.phaseList.slice(updateIndex + 1),
        ],
      };
    case PHASE_DELETED:
      return {
        ...state,
        phaseList: state.phaseList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
